<template>
  <el-row class="mobile-menu text-center">
    <el-button
      class="menu-button"
      icon="icon-rectangle"
      @click="menuLeft()"
    />
    <router-link
      class="message"
      :to="{ name: 'Messages' }"
    >
      <el-button icon="icon-massage" />
    </router-link>
    <div class="title">
      <img
        class="logo"
        src="../../assets/Z1-W.svg"
      >
    </div>
    <div class="group">
      <div class="custom-search">
        <el-input
          v-model="search"
          prefix-icon="icon-search"
        >
          <template
            v-if="search"
            slot="suffix"
          >
            <i
              class="el-icon-circle-close"
              @click="clearSearch"
            />
          </template>
        </el-input>
      </div>
      <el-button
        class="filter-button"
        icon="icon-filter"
        @click="menuRight('filters')"
      />
    </div>
    <menu-left :show-left="toggleLeftMenu.show" />
    <menu-right
      :show-right="toggleRightMenu.show"
      :page="'filters'"
      :title="$t('menu.filter.title')"
    />
  </el-row>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { autoState } from '@fps/vue-toolkit/dist/util';
  import mutations from '@/store/temp/temp.mutationlist';
  import filterMutations from '@/store/filters/filters.mutationlist';
  import MenuLeft from './MenuLeft';
  import MenuRight from './MenuRight';

  export default {
    components: {
      MenuRight,
      MenuLeft,
    },
    data() {
      return {
        menu: 'menu-filters',
        animation: [],
      };
    },
    computed: {
      ...autoState(['search'], filterMutations.FILTER_SET, 500, 'filters'),
      ...mapGetters(['toggleLeftMenu', 'toggleRightMenu']),
    },
    methods: {
      clearSearch() {
        this.search = '';
      },
      menuLeft() {
        this.$store.commit(mutations.TOGGLE_LEFT_MENU, { show: true });
      },
      menuRight(page) {
        this.$store.commit(mutations.TOGGLE_RIGHT_MENU,
          { show: !this.toggleRightMenu.show, page });
      },
    },
  };
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Mobile/MobileMenu.vue